import { Navigate, Route } from 'react-router-dom';
import { apiDocsPlugin, ApiExplorerPage } from '@backstage/plugin-api-docs';
import { CatalogEntityPage, catalogPlugin } from '@backstage/plugin-catalog';
import {
  CatalogImportPage,
  catalogImportPlugin,
} from '@backstage/plugin-catalog-import';
import { ScaffolderPage, scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { orgPlugin } from '@backstage/plugin-org';
import { UserSettingsPage } from '@backstage/plugin-user-settings';
import { apis } from './apis';
import { entityPage } from './components/catalog/EntityPage';
import { Root } from './components/Root';

import {
  AlertDisplay,
  OAuthRequestDialog,
  SignInPage,
} from '@backstage/core-components';
import { createApp } from '@backstage/app-defaults';
import { AppRouter, FlatRoutes } from '@backstage/core-app-api';
import { CatalogGraphPage } from '@backstage/plugin-catalog-graph';
import { RequirePermission } from '@backstage/plugin-permission-react';
import { catalogEntityCreatePermission } from '@backstage/plugin-catalog-common/alpha';

import { IfsCatalogPage } from '../../../plugins/ifs-catalog/src';
import { AddEntityPage } from '../../../plugins/ifs-catalog/src/components/AddEntityPage/AddEntityPage';
import { DomainPage } from '../../../plugins/ifs-catalog/src/components/DomainPage/DomainPage';
import { DomainSystemsPage } from '../../../plugins/ifs-catalog/src/components/DomainPage/DomainSystemsPage';
import { SystemDetailsPage } from '../../../plugins/ifs-catalog/src/components/DomainPage/SystemDetailsPage';
import { CatalogDetailsPage } from '../../../plugins/ifs-catalog/src/components/CatalogDetailsPage/CatalogDetailsPage';
import { ToastWrapper } from '@WESCO-International/wdp-ui-components/components/toast';
import { RoleProvider } from '../../../plugins/ifs-catalog/src/role/RoleContext';

const app = createApp({
  apis,
  bindRoutes({ bind }) {
    bind(catalogPlugin.externalRoutes, {
      createComponent: scaffolderPlugin.routes.root,
      createFromTemplate: scaffolderPlugin.routes.selectedTemplate,
    });
    bind(apiDocsPlugin.externalRoutes, {
      registerApi: catalogImportPlugin.routes.importPage,
    });
    bind(scaffolderPlugin.externalRoutes, {
      registerComponent: catalogImportPlugin.routes.importPage,
    });
    bind(orgPlugin.externalRoutes, {
      catalogIndex: catalogPlugin.routes.catalogIndex,
    });
  },
  components: {
    SignInPage: props => <SignInPage {...props} auto providers={['guest']} />,
  },
});

const routes = (
  <FlatRoutes>
    <Route path="/" element={<Navigate to="catalog" />} />
    <Route path="/catalog" element={<IfsCatalogPage />} />
    <Route path="/catalog/add" element={<AddEntityPage />} />
    <Route
      path="/catalog/:namespace/:kind/:name"
      element={<CatalogEntityPage />}
    >
      {entityPage}
    </Route>
    <Route path="/create" element={<ScaffolderPage />} />
    <Route path="/api-docs" element={<ApiExplorerPage />} />
    <Route
      path="/catalog-import"
      element={
        <RequirePermission permission={catalogEntityCreatePermission}>
          <CatalogImportPage />
        </RequirePermission>
      }
    />
    <Route path="/settings" element={<UserSettingsPage />} />
    <Route path="/catalog-graph" element={<CatalogGraphPage />} />
    <Route path="/ifs-catalog" element={<IfsCatalogPage />} />
    <Route path="/domains" element={<DomainPage />} />
    <Route path="/domains/:domain" element={<DomainSystemsPage />} />
    <Route
      path="/domains/:domain/systems/:system"
      element={<SystemDetailsPage />}
    />
    <Route path="/catalog-details/:name" element={<CatalogDetailsPage />} />
  </FlatRoutes>
);

export default app.createRoot(
  <>
    <AlertDisplay />
    <OAuthRequestDialog />
    <ToastWrapper>
      <AppRouter>
        <RoleProvider>
          <Root>{routes}</Root>
        </RoleProvider>
      </AppRouter>
    </ToastWrapper>
  </>,
);
